import React, {Fragment} from "react";
import { connect } from "react-redux";
import {withRouter} from "react-router-dom";
import {injectIntl} from "react-intl";

import LookWizardSectionGroup from "./lookWizardSectionGroup";
import {
  displayMaterialsWizardGroupAsFeature,
  getFeatureGroupFromWizardGroup, getWizardStepName
} from "./lookWizardFunctions";
import LookWizardSectionList from "./lookWizardSectionList";
import PropTypes from "prop-types";
import LookWizardSectionFilters from "./lookWizardSectionFilters";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import LookViewTypeSwitcher from "../lookViewTypeSwitcher";
import LookFeatureRevertButton from "../lookFeature/lookFeatureRevertButton";


const LookWizardSection = (props) => {

  const {wizardActiveItem, wizardStep, contentHeight, currentGroups, intl, fabricatorData, isMobile, activeQuoteIndex} = props;

  if (!wizardActiveItem) {
    return null
  }

  if (!currentGroups.length) {
    return null
  }

  let featureGroup = null;
  const wizardGroup = currentGroups[0];
  if (currentGroups.length === 1 && currentGroups[0].nodeType === "group") {
    featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
  }

  const wizGroupTitle = getWizardStepName(wizardGroup, featureGroup, activeQuoteIndex, intl, fabricatorData);

  const header = IS_PRODUCT_JOURNEY ? (
    <div className="grohe-features__title grohe-features__title--wizard">
      <span className="grohe-features__title-text">{wizGroupTitle}</span>
    </div>
  ) : isMobile ? (
    <div className="lm-header lm-header--wizard">
      <h3 className="p-0 lw-content__title flex--1 leading-1">
        {wizGroupTitle}
      </h3>
      <div className="lm-header__buttons">
        <LookViewTypeSwitcher isWizard={true}/>
        <LookFeatureRevertButton featureGroup={featureGroup} isWizard={true}/>
      </div>
    </div>
  ) : (
    <h3 className="lw-content__title">{wizGroupTitle}</h3> // desktop wizard list category header
  );


  const getContent = () => {
    if (displayMaterialsWizardGroupAsFeature(currentGroups)) {
      return currentGroups.map(currentGroup => {
        const featureGroup = getFeatureGroupFromWizardGroup(currentGroup);
        return <LookWizardSectionGroup key={currentGroup.id} wizardGroup={currentGroup} featureGroup={featureGroup}/>
      })
    }

    if (currentGroups[0].nodeType === "filter") {
      return <LookWizardSectionFilters wizardGroup={currentGroups[0]}/>
    }

    // console.log("currentGroups", currentGroups);

    return <LookWizardSectionList wizardGroup={currentGroups[0]}
                                  featureGroup={featureGroup}
                                  wizardStepIndex={wizardStep.stepIndex}
                                  contentHeight={contentHeight}/>
  }

  return (
    <Fragment>
      {header}
      {getContent()}
    </Fragment>
  )
};

LookWizardSection.propTypes = {
  wizardStep: PropTypes.object.isRequired,
  contentHeight: PropTypes.number,
  currentGroups: PropTypes.array.isRequired,
};

const mapStateToProps = (store) => {
  const {wizardActiveItem, wizardActiveStep} = store.wizardState;
  const {isMobile} = store.serverState;
  const {activeQuoteIndex} = store.quotesState;

  return {
    wizardActiveItem,
    wizardActiveStep,
    isMobile,
    fabricatorData: store.fabricatorState,
    activeQuoteIndex
  };
};

export default injectIntl(
  withRouter(connect(mapStateToProps)(LookWizardSection))
)
